import './AddUserInfo.css';
import updateUserData from '../../../assets/functions/updateUserData'
import React, {useState} from "react";

function AddProject(props) {

    const [projectTitle, setProjectTitle] = useState("");
    const [projectShortname, setProjectShortname] = useState("");
    const [projectColor, setProjectColor] = useState("#FFFFFF");

    const handleTitleChange = (event) => {
        setProjectTitle(event.target.value);
      };

      const handleShortnameChange = (event) => {
        setProjectShortname(event.target.value);
      };

      const handleProjectColor = (event) => {
        setProjectColor(event.target.value);
      };

      function resetAddProject() {
        setProjectTitle("")
        setProjectShortname("")
        setProjectColor('#FFFFFF')
      }

    function addProject() {
        if (props.pushChanges) {
            let projectCopy = [...props.userProfile.projects]
            projectCopy.push( {
            "title": projectTitle,
            "shortName": projectShortname,
            "backgroundColor": projectColor,
            })
        updateUserData("updateProjects", projectCopy, props.userProfile, props.setUserProfile, props.hideAddProject)
        } else {
            let projectCopy = [...props.projects]
            projectCopy.push( {
            "title": projectTitle,
            "shortName": projectShortname,
            "backgroundColor": projectColor,
            })
            props.setProjects(projectCopy)
            resetAddProject()
        }
    }

    return (
        <div className="addUserInfo">
            <div className="projectRow">
                <div>
                    <p className="addProjectTextHeader">project title</p>
                    <textarea
                    className="addUserInfoInputDiv"
                    type="text"
                    id="projectTitle"
                    value={projectTitle}
                    onChange={handleTitleChange}
                    name="projectTitle"
                    spellCheck="false"
                    />
                </div>
                <div>
                    <p className="addProjectTextHeader">short name</p>
                    <textarea
                    className="addUserInfoInputDiv shortInputDiv"
                    type="text"
                    id="projectShortname"
                    value={projectShortname}
                    onChange={handleShortnameChange}
                    name="projectShortname"
                    spellCheck="false"
                    />
                </div>

            </div>
                          <div className="colorTextHeader">
                    <p className="addProjectTextHeader">select a color tag for your project</p>
                    <input type="color" id="projectColor" value={projectColor} onChange={handleProjectColor}></input>
                </div>

            <p onClick={()=> addProject()} className="addUserInfoButton"> add project</p>
        </div>
    )
}

export default AddProject;